import { useSetAtom } from "jotai";
import React from "react";
import { editorStateAtom } from "../state/editor-state";
import { editorViewAtom } from "../state/editor-view";
import { historyWriteAtom } from "../state/history";
import subscribeOnUpdates from "../utils/subscribe-on-updates";
export function useSubscribeToEditorView(editorView, diffWorkerInstance) {
  var setEditorView = useSetAtom(editorViewAtom);
  var historyDispatcher = useSetAtom(historyWriteAtom);
  var setEditorState = useSetAtom(editorStateAtom);
  var diffWorker = diffWorkerInstance ? import("../state/json-diff-worker").then(function (_ref) {
    var JsonDiffWorker = _ref.JsonDiffWorker;
    return new JsonDiffWorker(diffWorkerInstance);
  }) : import("../state/json-diff-main").then(function (_ref2) {
    var JsonDiffMain = _ref2.JsonDiffMain;
    return new JsonDiffMain();
  });
  React.useEffect(function () {
    // set initial editor state
    setEditorState(editorView.state);

    // store editor view reference
    setEditorView(editorView);
    historyDispatcher({
      type: "reset",
      payload: {
        state: editorView.state
      }
    });
    subscribeOnUpdates(editorView, function (tr, oldState, newState) {
      setEditorState(newState);
      historyDispatcher({
        type: "update",
        payload: {
          oldState: oldState,
          newState: newState,
          tr: tr,
          diffWorker: diffWorker
        }
      });
    });
  }, [editorView, diffWorker]);
}